import styled from 'styled-components';
import decBg from '../../assets/images/dec_bg.png';

const StyledContainer = styled.div`
	position: absolute;
	top: 40px;
	left: 40px;
	width: 640px;
	height: 1000px;
	background-color: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	padding: 40px;
	overflow: hidden;
`;

const StyledDecBg = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 2400px;
	height: 2400px;
	background-image: url(${decBg});
	background-size: cover;
	background-position: center;
	pointer-events: none;
`;

const StyledDecBgTop = styled(StyledDecBg)`
	top: -1200px;
	left: -1200px;
`;

const StyledDecBgBottom = styled(StyledDecBg)`
	bottom: -1200px;
	right: -1200px;
`;

const StyledHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 40px;
`;

const StyledLogoContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;
	pointer-events: none;
	user-select: none;
`;

export {
	StyledContainer,
	StyledDecBgBottom,
	StyledDecBgTop,
	StyledHead,
	StyledLogoContainer,
};
